import { Box, TextField, Snackbar, Button } from '@mui/material';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getCopilotConfig,
    setAudioTranscript,
} from '../ccf-app-space/ccf-copilot/ccf-copilot-chat/+state/ccf-live-copilot.slice';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { v5 as uuidv5, NIL as namespaceNIL } from 'uuid';
import {
    API_BASE_URL,
    callApi,
    PROCESS_UTTERANCE,
} from '../ccf-app-space/ccf-copilot/ccf-copilot-api';

// eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
export const CcfPatronLite: React.FC = () => {
    const [contactId, setContactId] = useState('');
    const [isRecording, setIsRecording] = useState(false);
    const [isMuted, setIsMuted] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState(['', 'green']);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const socketRef = useRef<WebSocket | null>(null);
    // const copilotConfigurations = useSelector(getCopilotConfig);
    const copilotConfigurations = JSON.parse(localStorage.getItem('agentAssistAppConfig') as string) || {};
    // console.log('copilotConfigurations:', copilotConfigurations);
    const languageCode =
        copilotConfigurations?.language?.toLowerCase() ?? 'en-us';
    const namespace = uuidv5('namespace', namespaceNIL);
    const dispatch = useDispatch();

    const requestBody = {
        contactId: contactId,
        busNo: 12345678,
        tenantId: '12345678',
        participantId: '',
        messageBody: '',
        getSalesOffers: false,
        getCompliance: false,
        getKbCombo: false,
        getProcessSteps: false,
        getConversationAssistance: false,
        messageMetaData: {
            completeUtterance: true,
        },
        transcriptionEventId: '',
        threshold_sales: copilotConfigurations?.threshold_sales ?? 0.75,
        threshold_compliance: copilotConfigurations?.threshold_compliance ?? 0.75,
        agentAssistAppConfig: {
            language: languageCode,
            generativeResponseTone:
                copilotConfigurations?.generativeResponseTone ?? 'Formal',
            channels: ['digital', 'voice'],
            transcriptionProfileName: 'google-test',
            enableSentiment: copilotConfigurations?.enableSentiment ?? true,
            sentimentResponseLength:
                copilotConfigurations?.sentimentResponseLength ?? 20,
            realTimeSummary: copilotConfigurations?.realTimeSummary ?? true,
            realTimeSummaryResponseLength:
                copilotConfigurations?.realTimeSummaryResponseLength ?? 25,
            finalSummary: copilotConfigurations?.finalSummary ?? true,
            finalSummaryResponseLength:
                copilotConfigurations?.finalSummaryResponseLength ?? 65,
            behavioralGuidance: true,
            behavioralGuidanceResponseLength: 10,
            behevioralGuidanceNumberOfResponse: 3,
            enableExpertCopilotIntegration: true,
            expertCopilotURL: copilotConfigurations?.expertCopilotURL ?? '',
            expertCopilotClientKey:
                copilotConfigurations?.expertCopilotClientKey ?? '',
            expertCopilotClientSecret:
                copilotConfigurations?.expertCopilotClientSecret ?? '',
            path: 'hcaPropTaxes',
            botPersona: copilotConfigurations?.botPersona ?? '',
            kBAnswersPath: copilotConfigurations?.kBAnswersPath ?? '',
            salesOffersPath: copilotConfigurations?.salesOffersPath ?? '',
            compliancePath: copilotConfigurations?.compliancePath ?? '',
            nextBestResponse: copilotConfigurations?.nextBestResponse ?? true,
            nextBestResponseLength:
                copilotConfigurations?.nextBestResponseLength ?? 20,
            nextBestNumberOfResponse:
                copilotConfigurations?.nextBestNumberOfResponse ?? 2,
            knowledgeBaseArticles:
                copilotConfigurations?.knowledgeBaseArticles ?? true,
            knowledgeBaseArticlesResponseLength:
                copilotConfigurations?.knowledgeBaseArticlesResponseLength ?? 2,
            knowledgeBaseWebLinks:
                copilotConfigurations?.knowledgeBaseWebLinks ?? true,
            knowledgeBaseMaximumWebLinks:
                copilotConfigurations?.knowledgeBaseMaximumWebLinks ?? 3,
            knowledgeBaseImages: copilotConfigurations?.knowledgeBaseImages ?? true,
            knowledgeBaseMaximumImages:
                copilotConfigurations?.knowledgeBaseMaximumImages ?? 3,
            knowledgeBaseProcessSteps:
                copilotConfigurations?.knowledgeBaseProcessSteps ?? true,
            knowledgeBaseMaximumSteps:
                copilotConfigurations?.knowledgeBaseMaximumSteps ?? 10,
            threshold: copilotConfigurations?.threshold ?? 0.75,
            vendorId: 'agentCopilot',
            agentAssistId: 'Ved_acp_test123',
            scriptParams: '',
            backAndForthLiveConvo:
                copilotConfigurations?.backAndForthLiveConvo ?? false,
            backAndForthLiveConvoLength:
                copilotConfigurations?.backAndForthLiveConvoLength ?? 4,
        },
        messageIsCompletedUtterance: true,
        agentId: 1898,
        mediaType: 'Voice',
        totalAudioChunksInMilliSeconds: 2040,
    };

    // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        if (!socketRef.current || socketRef.current.readyState !== WebSocket.OPEN) {
            // let utterances: string[] =[]; //array to store the utterances
            // Establish WebSocket connection
            socketRef.current = new WebSocket(`wss://api.deepgram.com/v1/listen?model=nova-2&language=en-US&smart_format=true&interim_results=false&vad_events=false&callback=https://1tx1doz6q5.execute-api.us-west-2.amazonaws.com/test/agentcopilotapi/v1/transcription/callback/patron?contactId=${contactId}`, [
                'token',
                '8c1698cb02286db59314fa30e32fdc00ef668aa3',
            ]);
            // let keepAliveInterval: NodeJS.Timeout;
            socketRef.current.onopen = () => {
                console.log('WebSocket connection established');
                setInterval(() => {
                    const keepAliveMsg = JSON.stringify({ type: "KeepAlive" });
                    socketRef?.current?.send(keepAliveMsg);
                }, 3000);
            };

            socketRef.current.onmessage = (message) => {
                try {
                //   console.log({ event: 'onmessage', message });
                  const received = JSON.parse(message.data);
                  const sentence = received?.channel?.alternatives?.[0]?.transcript || '';
                  if (sentence.length > 0 && received.is_final) {
                    const timestamp = new Date().toLocaleTimeString('en-US', { hour12: true });
                    console.log('%c Transcript: [', 'color:red', timestamp, '] ' , sentence);

                    // We need to collect these and concatenate them together when we get a speech_final=true
                    // utterances.push(sentence);

                    const customerRequestBody = {
                        ...requestBody,
                        messageBody: sentence,
                        participantId: 'patron',
                        transcriptionEventId: uuidv5(sentence, namespace),
                        path: 'hcaPropTaxes', //temporary path
                      };

                      //Send transcription result to process-utterance API
                      sendToProcessUtteranceAPI(customerRequestBody, sentence);

                    // // Speech final means we have detected sufficent silence to consider this end of speech
                    // if (received.speech_final) {
                    //   const finalSpeech = utterances.join(' ');
                    //   console.log(`Speech Final: ${finalSpeech}`);
                    //   utterances = [];

                    //   // dispatch(setAudioTranscript(`Customer: ${transcript}`));
                    //   // setTimeout(() => {
                    //   //   dispatch(setAudioTranscript(''));
                    //   // }, 5000);
                    //   const customerRequestBody = {
                    //     ...requestBody,
                    //     messageBody: sentence,
                    //     participantId: 'patron',
                    //     transcriptionEventId: uuidv5(sentence, namespace),
                    //     path: 'hcaPropTaxes', //temporary path
                    //   };

                    //   //Send transcription result to process-utterance API
                    //   sendToProcessUtteranceAPI(customerRequestBody, sentence);
                    // } else {
                    //   // These are useful if you need real time captioning and update what the Interim Results produced
                    //   console.log(`Is Final: ${sentence}`);
                    // }
                  } else {
                    // These are useful if you need real time captioning of what is being spoken
                    // console.log(`Interim Results: ${sentence}`);
                  }
                } catch (error) {
                  console.log('Error parsing message:', error);
                }
            };

            socketRef.current.onclose = () => {
                console.log({ event: 'onclose' });
                // clearInterval(keepAliveInterval);
                setIsRecording(false);
                setSnackbarMessage(['Audio streaming stopped', 'red']);
                setSnackbarOpen(true); // Show Snackbar
            };

            socketRef.current.onerror = (error) => {
                console.log({ event: 'onerror', error });
                // clearInterval(keepAliveInterval);
                setSnackbarMessage(['Error occurred while streaming audio', 'red']);
                setSnackbarOpen(true); // Show Snackbar
                // socketRef.current
            };


        if (!mediaRecorderRef.current) {
            console.log('MediaRecorder is not initialized');
            // Start recording audio
            navigator.mediaDevices
                .getUserMedia({ audio: true })
                .then((stream) => {
                    mediaRecorderRef.current = new MediaRecorder(stream);
                    mediaRecorderRef.current.ondataavailable = (e) => {


                        if (
                            socketRef.current &&
                            socketRef.current.readyState === WebSocket.OPEN
                        ) {
                            const timestamp = new Date().toLocaleTimeString('en-US', { hour12: true });
                            console.log('Sending audio data to WebSocket server... [', timestamp, ']' , e.data?.size);
                            socketRef?.current?.send(e.data);
                        }
                    };
                    mediaRecorderRef.current.start(100); // Send audio data every 100ms
                    setIsRecording(true);
                    setSnackbarMessage(['Microphone enabled', 'green']);
                    setSnackbarOpen(true); // Show Snackbar
                })
                .catch((error) => {
                    console.error('Error accessing media devices.', error);
                    setSnackbarMessage(['Error accessing microphone', 'red']);
                    setSnackbarOpen(true); // Show Snackbar
                });

            }
            else{
                console.log('MediaRecorder is already initialized, current state:', mediaRecorderRef.current?.state);

            }
        }

        // if (mediaRecorderRef.current?.state === 'inactive') {
        //     console.log('Re-starting Audio streaming again...');
        //     mediaRecorderRef.current?.start(100);
        //     setSnackbarMessage(['Re-starting Audio streaming ...', 'pale yellow']);
        //     setSnackbarOpen(true); // Show Snackbar
        //     setIsRecording(true);
        // }

        if (mediaRecorderRef.current?.state === 'paused') {
            console.log('Resuming Audio streaming ...');

            mediaRecorderRef.current?.resume();
            setSnackbarMessage(['Resuming Audio streaming ...', 'orange']);
            setSnackbarOpen(true); // Show Snackbar
            setIsRecording(true);
        }


    };

    // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
    const sendToProcessUtteranceAPI = (
        customerRequestBody: any,
        audioTranscriptText: string
    ) => {
        if (audioTranscriptText !== '') {
            return new Promise<void>((resolve, reject) => {
                const apiCallPromises = [];
                apiCallPromises.push(
                    callApi(
                        API_BASE_URL + PROCESS_UTTERANCE,
                        'POST',
                        customerRequestBody,
                        dispatch
                    ).catch((error: any) => {
                        console.error('Error:', error);
                    })
                );
                apiCallPromises.push(
                    callApi(
                        API_BASE_URL + PROCESS_UTTERANCE,
                        'POST',
                        { ...customerRequestBody, getKbCombo: true },
                        dispatch
                    )
                        .then((response: any) => {
                            const timestamp = new Date().toLocaleTimeString('en-US', { hour12: true });
                            console.log('%c API Response Timestamp: [', 'color:blue', timestamp, '] ', response);
                            callApi(
                                API_BASE_URL + PROCESS_UTTERANCE,
                                'POST',
                                { ...customerRequestBody, getProcessSteps: true },
                                dispatch
                            ).catch((error: any) => {
                                console.error('Error:', error);
                            });
                        })
                        .catch((error: any) => {
                            console.error('Error:', error);
                        })
                );
                // salesOffers
                // salesOffers API call
                if (copilotConfigurations?.salesOffers ?? true) {
                    apiCallPromises.push(
                        callApi(
                            API_BASE_URL + PROCESS_UTTERANCE,
                            'POST',
                            { ...customerRequestBody, getSalesOffers: true },
                            dispatch
                        ).catch((error: any) => {
                            console.error('Error:', error);
                        })
                    );
                }
                // compliance
                // compliance API call
                if (copilotConfigurations?.compliance ?? true) {
                    apiCallPromises.push(
                        callApi(
                            API_BASE_URL + PROCESS_UTTERANCE,
                            'POST',
                            { ...customerRequestBody, getCompliance: true },
                            dispatch
                        ).catch((error: any) => {
                            console.error('Error:', error);
                        })
                    );
                }
                // conversation Assistance
                // conversation Assistance API call
                apiCallPromises.push(
                    callApi(
                        API_BASE_URL + PROCESS_UTTERANCE,
                        'POST',
                        { ...customerRequestBody, getConversationAssistance: true },
                        dispatch
                    ).catch((error: any) => {
                        console.error('Error:', error);
                    })
                );
                // Process all API call promises
                // Promise.allSettled(apiCallPromises).then(() => {
                //   dispatch(setIsRequestProcessing(false));
                // });
            });
        }
        return null;
    };

    // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
    const handleStopRecording = () => {
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.pause();
            setIsRecording(false);
        }
        if (socketRef.current) {
            // socketRef.current.close();
            socketRef.current.send(JSON.stringify({ type: "CloseStream" }));
        }
    };

    // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
    const handleMuteToggle = () => {
        // console.log("MediaRecorder current state :[before]: ",mediaRecorderRef.current?.state);
        if(!isMuted){
            mediaRecorderRef.current?.pause();
        }
        else{
            mediaRecorderRef.current?.resume();
        }
        // console.log("MediaRecorder current state :[after]: ",mediaRecorderRef.current?.state);
        setIsMuted((prev) => !prev);
    };

    /**
     * Handles the closing of the snackbar.
     * Sets the snackbar's open state to false.
     * @example handleSnackbarClose()
     */
    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    return (
      <Box component="div" sx={{ p: 2 }}>
        {/* <Box> */}
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
          >
            <TextField
              label="Contact ID"
              variant="outlined"
              value={contactId}
              onChange={(e) => setContactId(e.target.value)}
              required
            />
            <Box component="div" sx={{ display: 'flex', gap: 2 }}>
              <Button type="submit" variant="outlined" color="primary" disabled={isRecording}>
                Start Streaming
              </Button>
              {isRecording && (
              <>
                {/* <button onClick={handleStopRecording}>Stop Streaming</button> */}
                <Button
                  onClick={handleMuteToggle}
                  variant="contained"
                //   startIcon={isMuted ? <MicOffIcon /> : <MicIcon />}
                  color={isMuted ? 'error' : 'success'}
                >
                  {/* {isMuted ? 'Unmute' : 'Mute'} */}
                  {isMuted ? <MicOffIcon /> : <MicIcon />}
                </Button>
              </>
            )}
            </Box>
          </Box>
          {/* <Box component="div" sx={{ display: 'flex', gap: 2 }}>
            {isRecording && (
              <>
                <button onClick={handleStopRecording}>Stop Streaming</button>
                <button onClick={handleMuteToggle}>
                  {isMuted ? 'Unmute' : 'Mute'}
                </button>
              </>
            )}
          </Box> */}
        {/* </Box> */}
        <Snackbar
          open={snackbarOpen}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
          message={snackbarMessage[0]}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          ContentProps={{
            style: {
              backgroundColor: snackbarMessage[1],
            },
          }}
        />
      </Box>
    );
};

export default CcfPatronLite;
